const ChangeLogConstants = new Object();

ChangeLogConstants.CHANGE_LOG = {
    'active_key': 'product_collab_qa_change',
    'feature_detail' : [{
    'key': 'product_collab_qa_change',
    'feature_name': 'Product Collaborate QA',
    'feature_type': 'New Feature',
    'main_action': 'Start Reviewing',
    'route': '/home',
    'detail': [{
        'illustration_link': 'https://d48f7equ64qjl.cloudfront.net/static_files/change_log_images/1.png',
        'heading': 'Product QA: Now With Image Markup & Collaboration' ,
        'text': 'Reviewing your 3D product models is now easier than ever! And, we’ve streamlined the process for teams with collaboration mode.',
        'order': 1
    }, {
        'illustration_link': 'https://d48f7equ64qjl.cloudfront.net/static_files/change_log_images/2.png',
        'heading': 'Easily compare models and reference images at the same angle with auto-matched views.' ,
        'text': 'The appropriate reference image will automatically be paired side-by-side with the same model angle for seamless annotations.',
        'order': 2
    }, {
        'illustration_link': 'https://d48f7equ64qjl.cloudfront.net/static_files/change_log_images/3.png',
        'heading': 'Annotate your notes directly onto images to easily communicate your changes in context.' ,
        'text': 'Every model angle and side-by-side comparison are available for image markup making it easy to draw, write, or comment on any angle of your product.',
        'order': 3
    }, {
        'illustration_link': 'https://d48f7equ64qjl.cloudfront.net/static_files/change_log_images/4.png',
        'heading': 'Invite your team to collaborate in the QA process and keep everyone in the loop' ,
        'text': 'Add people directly in any message thread or invite an individual or saved group to a specific product.',
        'order': 4
    }]}]

}




export default ChangeLogConstants;